import {
  EyeStroke,
  FileMultipleStroke,
  Pencil1Stroke,
  PlusStroke,
  RefreshCircle1ClockwiseStroke,
  Search1Stroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { Lineicons } from '@lineiconshq/react-lineicons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { groupTypes } from '..';

interface ActionBarProps {
  onAddClick: () => void;
  onEditClick: () => void;
  onDeleteClick: () => void;
  onCopyClick: () => void;
  isEditDisabled?: boolean;
  onViewClick: () => void;
  isViewDisabled?: boolean;
  activeGroup: string;
  isLoading?: boolean;
  onRefresh?: () => void;
}

export const ActionBar = ({
  onAddClick,
  onEditClick,
  isEditDisabled = true,
  onViewClick,
  onDeleteClick,
  onCopyClick,
  isViewDisabled = true,
  activeGroup,
  isLoading = false,
  onRefresh
}: ActionBarProps) => {
  const activeGroupInfo = groupTypes.find(group => group.value === activeGroup);
  const displayText = activeGroupInfo
    ? `Phân nhóm: ${activeGroupInfo.shortCode} - ${activeGroupInfo.label}`
    : 'Phân nhóm CC - Nhóm tài sản công cụ dụng cụ';

  return (
    <ActionBarV2
      loading={isLoading}
      titleComponent={
        <div>
          <h1 className='text-xl font-bold'>Danh mục nhóm tài sản công cụ dụng cụ</h1>
          <div className='text-[10px] text-gray-500'>
            <p>
              <span className='mr-2 inline-block h-2 w-2 rounded-full bg-red-600'></span>
              <span className='font-semibold'>{displayText}</span>
            </p>
          </div>
        </div>
      }
    >
      {onAddClick && <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddClick} disabled={isLoading} />}
      {onEditClick && (
        <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditClick} disabled={isViewDisabled || isLoading} />
      )}
      {onDeleteClick && (
        <ActionButtonV2
          icon={Trash3Stroke}
          title='Xóa'
          onClick={onDeleteClick}
          disabled={isViewDisabled || isLoading}
        />
      )}
      {onCopyClick && (
        <ActionButtonV2
          icon={FileMultipleStroke}
          title='Sao chép'
          onClick={onCopyClick}
          disabled={isViewDisabled || isLoading}
        />
      )}
      {onViewClick && (
        <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onViewClick} disabled={isViewDisabled || isLoading} />
      )}
      <MenuButtonV2
        items={[
          {
            title: 'Tìm kiếm',
            icon: <Lineicons aria-hidden='true' icon={Search1Stroke} className='h-4 w-4' />,
            onClick: () => {},
            group: 0
          },
          {
            title: 'Làm mới',
            icon: <Lineicons aria-hidden='true' icon={RefreshCircle1ClockwiseStroke} className='h-4 w-4' />,
            onClick: onRefresh || (() => {}),
            group: 1
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: () => {},
            group: 1
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: () => {},
            group: 2
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: () => {},
            group: 3
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: () => {},
            group: 3
          }
        ]}
      />
    </ActionBarV2>
  );
};
